// src/App.js
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import AppRouter from './AppRouter';
import { ModalProvider } from './context/ModalContext';
import GlobalModal from './components/ConfirmationModal/GlobalModal';

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ModalProvider>
          <AppRouter />
          <GlobalModal />
        </ModalProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
